export default function prepareLDAPConfig(config: Record<string, unknown>): Record<string, unknown> {
  const userPasswd = config.user_passwd as { is_set?: boolean } | undefined;

  if (userPasswd && 'is_set' in userPasswd) {
    return {
      ...config,
      user_passwd: userPasswd.is_set ? { keep_value: true } : { set_value: '' },
    };
  }

  return config;
}
